module.exports = __webpack_public_path__ + "image/share-icon2.png";